import TopSections from './TopSections';

import { UK_PRIVATE_COMPANY_INSIGHTS_PATH } from '../../../../data/ukPrivateCompanyInsights';

import Styles from './styles.module.scss';

const TopGBPMinSection = (props) => {
  const { extraParams, natureOfBusiness } = props;
  const natureURL = natureOfBusiness ? `/${natureOfBusiness}` : '';

  return (
    <>
      <div className={Styles['uk-private-company-top']}>
        <TopSections
          title="Top Equity Fundraisers (GBP)"
          tooltipText="Companies that raised the most in private funding in the specified year."
          seeMoreUrl={`${UK_PRIVATE_COMPANY_INSIGHTS_PATH}/top-equity-fundraisers${natureURL}`}
          type="fundraising"
          extraParams={extraParams}
        />
        <TopSections
          title="Holdings of Top Investors"
          tooltipText="The number of investments and aggregate holdings for the largest UK private investors."
          seeMoreUrl={`${UK_PRIVATE_COMPANY_INSIGHTS_PATH}/top-investors${natureURL}`}
          type="investors"
          extraParams={extraParams}
          hideFilters
        />
      </div>
      <div className={Styles['uk-private-company-top']}>
        <TopSections
          title="Top Companies by Last Round Valuation (GBP)"
          tooltipText="Companies with the highest valuation based on their last funding round in the specified year. Companies without funding in the specified year will not appear."
          seeMoreUrl={`${UK_PRIVATE_COMPANY_INSIGHTS_PATH}/top-companies-by-market-capitalisation${natureURL}`}
          type="market"
          extraParams={extraParams}
        />
        <TopSections
          title="Companies With Highest ROI"
          tooltipText="Companies that returned the highest capital gains on an investment for the specified year. "
          seeMoreUrl={`${UK_PRIVATE_COMPANY_INSIGHTS_PATH}/companies-with-highest-roi${natureURL}`}
          type="roi"
          extraParams={extraParams}
        />
      </div>
    </>
  );
};

export default TopGBPMinSection;
